<template>
  <v-layout>
    <v-flex>
      <v-layout align-center>
        <h1 class="headline">Internal Statuses</h1>
        <v-spacer></v-spacer>
        <v-flex xs12 sm4 class="pb-2">
          <v-text-field
            append-icon="mdi-magnify"
            label="Quick Filter..."
            single-line
            hide-details
            v-model="search"
            class="ma-0"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn v-on="on" fab dark color="primary" @click="createItem" class="mx-2">
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Create New Internal Status</span>
        </v-tooltip>
      </v-layout>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="internalStatuses.edges"
          :loading="$apollo.loading"
          v-bind="pagingOptions"
          :search="search"
          item-key="node.id"
        >
          <template v-slot:item.actions="{item}">
            <default-list-actions
              :item="item"
              :hide-view="true"
              @deleteItem="deleteItem($event)"
              @editItem="editItem($event)"
            ></default-list-actions>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="statusEditorDialog" persistent width="500" scrollable>
        <v-card>
          <internal-status-editor
            :status="selectedStatus"
            :doSaveStatus="doSaveStatus"
            :statusEditorDialog="statusEditorDialog"
            @saved="onSaved($event)"
            @onResetSave="onResetSave"
          ></internal-status-editor>
          <v-card-actions class="grey lighten-4">
            <v-spacer></v-spacer>
            <v-btn color="warning" text @click="closeDialog">Cancel</v-btn>
            <v-btn color="primary" @click="onSaveStatus">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  ALL_INTERNAL_STATUSES_SEARCH_QUERY,
  INTERNAL_STATUS_DELETE_MUTATION
} from "../../../../constants/graphql";
import InternalStatusEditor from "./InternalStatusEditor";
import DefaultListActions from "../../shared/DefaultListActions";
import { pagingOptions } from "../../../../helpers/index";

export default {
  name: "InternalStatusesList",

  components: {
    DefaultListActions,
    InternalStatusEditor
  },

  data() {
    return {
      pagingOptions,
      search: "",
      selectedStatus: {},
      doSaveStatus: false,
      internalStatuses: {},
      statusEditorDialog: false,
      headers: [
        {
          text: "Name",
          value: "node.name",
          name: "name"
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center"
        }
      ]
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    }
  },

  methods: {
    createItem() {
      this.selectedStatus = {};
      this.statusEditorDialog = true;
    },
    editItem(item) {
      this.selectedStatus = item.node;
      this.statusEditorDialog = true;
    },
    deleteItem(item) {
      this.$apollo
        .mutate({
          mutation: INTERNAL_STATUS_DELETE_MUTATION,
          variables: {
            internalStatusId: item.node.id
          }
        })
        .then(this.removeGqlObjectHandler, this.removeGqlObjectErrorHandler);
    },
    removeGqlObjectHandler(result) {
      this.$store.dispatch("showAppSnackbar", {
        msg: "Internal status removed."
      });

      if (this.$apollo.queries.internalStatuses != null) {
        this.$apollo.queries.internalStatuses.refetch();
      }
    },
    removeGqlObjectErrorHandler(err) {
      this.$store.dispatch("showAppSnackbar", {
        msg: err.graphQLErrors[0].message,
        color: "error"
      });
    },
    onSaved(context) {
      if (this.$apollo.queries.internalStatuses != null) {
        this.$apollo.queries.internalStatuses.refetch();
      }
      this.onResetSave();
      this.statusEditorDialog = false;
      this.selectedStatus = {};
      let msg =
        context == "edit"
          ? "Internal status updated."
          : "Internal status created.";
      this.$store.dispatch("showAppSnackbar", { msg });
    },
    onResetSave() {
      this.doSaveStatus = false;
    },
    closeDialog() {
      this.statusEditorDialog = false;
      this.selectedStatus = {};
    },
    onSaveStatus() {
      this.doSaveStatus = true;
    }
  },

  apollo: {
    internalStatuses: {
      query: ALL_INTERNAL_STATUSES_SEARCH_QUERY,
      fetchPolicy: "network-only",
      result({ data, loader, networkStatus }) {}
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/gt/admin/department-types/InternalStatusesList.vue